import { render, staticRenderFns } from "./TipsInfoPremium.vue?vue&type=template&id=7e231f2c&scoped=true&"
import script from "./TipsInfoPremium.vue?vue&type=script&lang=js&"
export * from "./TipsInfoPremium.vue?vue&type=script&lang=js&"
import style0 from "./TipsInfoPremium.vue?vue&type=style&index=0&id=7e231f2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e231f2c",
  null
  
)

export default component.exports